export const PermissionAuthorityGroups = {
    PUT: "mgr-authority-groups-**-PUT",
    POST: "mgr-authority-groups-POST",
    DELETE: "mgr-authority-groups-**-DELETE",
    GET: "mgr-authority-groups-search-GET",
    GET_UUID: "mgr-authority-groups-**-GET"
};